export const ITIL_SECTION_DELIMITER = '\n## ';

export const ITIL_TEMPLATE_KEY = 'itil';

export const ITIL_DESCRIPTION_FIELD_KEY = 'activitiesDescription';

export const ITIL_CLOSE_COMMENTS_FIELD_KEY = 'closeComments';

export const ITIL_TRANSLATION_TYPE_BY_SCOPE = {
  description: 'Description',
  creationComment: 'CreationComment',
  closing: 'CloseComment'
} as const;

export const ITIL_CLOSE_MARKER = 'Traducción ITIL (Cierre):';

/** Matches any "Traducción ITIL (…):" marker embedded in ticket comments */
export const ITIL_COMMENT_MARKER_REGEX = /Traducción ITIL \([^)]+\):/;
